
import { RootState } from '..';
import { useTypedSelector } from '../../hooks/useTypedSelector';

export const useCampaignsSelector = () =>
  useTypedSelector((state: RootState) => state.campaigns);